module.exports = __webpack_public_path__ + "img/login-bg.c61de930.jpg";